require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ahram-classified-ads.json") })
        }
      }, "path---ahram-classified-ads");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ahram-classified-ads!./.cache/json/ahram-classified-ads.json
// module id = 533
// module chunks = 231608221292675